import type { AiExploreTheme } from './types.js';
import { THEME_LABELS } from './types.js';

const THEME_ORDER: AiExploreTheme[] = [
  'any',
  'rest_toilet',
  'convenience_store',
  'food',
  'emergency',
  'scenic',
  'bath',
];

interface Props {
  onSelect: (theme: AiExploreTheme) => void;
  onClose: () => void;
}

export function AiThemeSelector({ onSelect, onClose }: Props) {
  return (
    <div className="fixed inset-0 z-[2000] flex items-end" onClick={onClose}>
      <div
        className="w-full bg-white rounded-t-2xl shadow-xl pb-safe"
        onClick={(e) => e.stopPropagation()}
        style={{ paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 16px)' }}
      >
        {/* ヘッダー */}
        <div className="flex items-center justify-between px-4 pt-4 pb-2">
          <h2 className="text-base font-semibold text-gray-800">探索テーマを選択</h2>
          <button
            type="button"
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-full text-gray-400 hover:bg-gray-100 active:bg-gray-200"
            aria-label="閉じる"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path
                d="M18 6L6 18M6 6l12 12"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </button>
        </div>

        {/* テーマグリッド */}
        <div className="grid grid-cols-4 gap-2 px-4 pt-2">
          {THEME_ORDER.map((theme) => {
            const { label, icon, description } = THEME_LABELS[theme];
            return (
              <button
                key={theme}
                type="button"
                onClick={() => onSelect(theme)}
                className="flex flex-col items-center gap-1 p-3 rounded-xl bg-gray-50 hover:bg-primary/10 active:bg-primary/20 transition-colors"
              >
                <span className="text-2xl leading-none">{icon}</span>
                <span className="text-xs font-medium text-gray-700 text-center leading-tight">
                  {label}
                </span>
                <span className="text-[10px] text-gray-400 text-center leading-tight">
                  {description}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
